import React, { useEffect, useRef } from 'react';
import { Col, Container, ListGroup, Row } from "react-bootstrap";

/**
 * Dropdown that allows to select a single items. Select choices are applied immediately.
 */
export const SingleSelectMenu = ({ setShow, option, selectedItem, updateFilterOptions, availableItems }: any) => {

    const wrapperRef: any = useRef(null);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShow(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    return (
        <div ref={wrapperRef} className="filter-select-container">
            <Container className="p-0">
                <Row className="">
                    <Col md={12}>
                        <ListGroup>
                            {
                                availableItems.map((selectOption: any, index: number) => {
                                    return (
                                        <ListGroup.Item key={selectOption.id} action className={selectedItem === index ? "select-active" : ""} onClick={() => {updateFilterOptions(option, index); setShow(false)}}>
                                            {selectOption.name}
                                        </ListGroup.Item>
                                    )
                                })
                            }
                        </ListGroup>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
